import { useEffect } from "react";
import { useTranslation } from "react-i18next";
// Ignore note: Utility import considered ok
// eslint-disable-next-line caspeco/discourage-chakra-import
import { Slide } from "@chakra-ui/react";
import {
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeFontVariable,
	ThemeShadowVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Box } from "@caspeco/casper-ui-library.components.box";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import { Button } from "@caspeco/casper-ui-library.components.button";
import { Icons } from "@caspeco/casper-ui-library.components.icon";
import { IconButton } from "@caspeco/casper-ui-library.components.icon-button";
import { Heading } from "@caspeco/casper-ui-library.components.heading";
import { CSSVarColumnWidthSmall, CSSVarHeaderHeight } from "components/global-styles/GlobalStyles";

interface IUpsellDesktopContainer {
	children: React.ReactNode;
	isOpen: boolean;
	onClose: () => void;
}

export function UpsellDesktopContainer({ isOpen, onClose, children }: IUpsellDesktopContainer) {
	const { t } = useTranslation();

	useEffect(() => {
		if (!isOpen) return;
		// On open, scroll upsell container to top
		const scrollContainer = document.querySelector("div[id='upsell-scrollcontainer']");
		if (!scrollContainer) return;
		scrollContainer.scroll(0, 0);
	}, [isOpen]);

	// Full height minus the height of application header
	const height = `calc(100% - ${CSSVarHeaderHeight})`;
	// Full width minus the max width of cart
	const maxWidth = `calc(100% - ${CSSVarColumnWidthSmall})`;

	return (
		<Slide in={isOpen} direction="bottom" style={{ width: "70%", maxWidth }}>
			<Box bg={ThemeColorVariable.Surface} h={height}>
				<Flex h={`calc(100vh - ${CSSVarHeaderHeight})`} direction="column" justifyContent="space-between">
					<Box id="upsell-scrollcontainer" overflowY="auto">
						<Flex justifyContent="flex-end" p={ThemeSpaceVariable.Medium}>
							<IconButton icon={Icons.Close} aria-label={t("action_close")} onClick={onClose} />
						</Flex>
						<Heading
							as="h2"
							px={ThemeSpaceVariable.Medium}
							fontWeight="bold"
							fontFamily={ThemeFontVariable.Header}
							color={ThemeColorVariable.OnSurfaceHeader}
							fontSize={{
								base: ThemeFontSizeVariable.XLarge,
								md: ThemeFontSizeVariable.X3Large,
							}}
						>
							{t("article_upsell_title")}
						</Heading>
						<Box px={ThemeSpaceVariable.Medium} pt={ThemeSpaceVariable.Medium} pb="32px">
							{children}
						</Box>
					</Box>
					<Flex
						p={ThemeSpaceVariable.Medium}
						w="100%"
						boxShadow={ThemeShadowVariable.Footer}
						justify="flex-end"
						bg={ThemeColorVariable.Surface}
						align="center"
						zIndex={1}
					>
						<Button onClick={onClose} size="lg" variant="primary">
							{t("menu_back_to")}
						</Button>
					</Flex>
				</Flex>
			</Box>
		</Slide>
	);
}
